import { useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import Search from "./header/Search"
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format,startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { Table, Spin } from "antd"
import "./scss/report.scss"
import StorageService from "../../utils/storage.service";

const ReportEmulation = () => {
    const columns = [
        {
            title: 'Tên chương trình',
            dataIndex: 'rule_name',
            with: 150,
            render: (data) => {
                return (
                    <p className="text_service_none">{data}</p>
                )
            },
        },
        {
            title: 'Target',
            dataIndex: 'target',
            render: (data) => {
                return (
                    <p className="text7">{data < 100 ? data + ' Sp' : convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Bắt đầu',
            dataIndex: 'start_date',
            render: (data) => {
                return (
                    <p className="text4">{convertDateTime(data)}</p>
                )
            },
        },
        {
            title: 'Kết thúc',
            dataIndex: 'end_date',
            render: (data) => {
                return (
                    <p className="text2">{convertDateTime(data)}</p>
                )
            },
        },
        {
            title: 'Nhân viên',
            dataIndex: 'user_name',
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Đã đạt',
            dataIndex: 'is_target',
            render: (data) => {
                return (
                    <p className="text1">{data < 1000 ? data + " Sp": convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Đạt mốc',
            dataIndex: 'keyNa',
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Thưởng',
            dataIndex: 'bonus',
            align: 'center',
            render: (data) => {
                return (
                    <p className="text7">{(data > 100) ? convertCurrency(data) : data + "%"}</p>
                )
            },
        },
        {
            title: 'Tổng mốc',
            dataIndex: 'total_action',
            align: 'center',
            render: (data) => {
                return (
                    <p className="text_service_none">{data}</p>
                )
            },
        },
        {
            title: 'Xếp hạng',
            dataIndex: 'rank',
            align: 'center',
            render: (data) => {
                return (
                    <p className="text3">{ Number(data) > 0 ? String(data).padStart(2, '0') : ''}</p>
                )
            },
        },
    ];
    const title = "Báo cáo Thi Đua"
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState([])
    const [totalPaid, setTotalPaid] = useState(0)
    const [userId, setUserId] = useState(0)
    const [emulationId, setEmulationId] = useState(0)
    const [pageSize, setPageSize] = useState(15)
    const [userName, setUserName] = useState(null)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [emulationOption, setEmulationOption] = useState([])


    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }

    const handleUser = (x) => {
        setUserId(x.value)
        setUserName(x.label)
    }

    const handleEmulation = (x) => {
        setEmulationId(x.value)
    }

    function convertDateTime(event) {
        let date = new Date(event),
            month = date.getMonth() + 1,
            day = date.getDate();

        if (day < 10) day = '0' + day;
        if (month < 10) month = '0' + month;
        let text = date.getFullYear() + '-' + month + '-' + day ;
        return text
    };
    const fetchData = async (sD, eD, s) => {
        const { emulation, data } = await async.parallel({
            emulation: (cb) => {
                axiosService(`api/emulation/`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
            data: (cb) => {
                axiosService(`api/emulation/report/find?start=${sD}&end=${eD}&store=${store}&user_id=${userId}&emulation_id=${emulationId}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const { dataTable } = data.data

            setTable(dataTable)

            const newEmulation = emulation.data.items.map(x => {
                return { label: x.rule_name, value: x.id }
            })
            setEmulationOption([{ label: "Tất cả", value: 0},...newEmulation])

        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store,keyword, userId, emulationId])

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <>
        <div className={`container-fluid ${styles.background}`}>
            <Search startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                handleUser={handleUser}
                handleEmulation={handleEmulation}
                title={title} type={"emulation"}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                emulation = {emulationOption}
                header={
                    [
                        { label: 'Nhân viên', key: "user_name" },
                        { label: "Số lịch đã xác nhận", key: "countBooking" },
                        { label: "Hoa hồng xác nhận lịch", key: "rose_confirm" },
                        { label: "Số khách đón tiếp", key: `countCustomer` },
                        { label: "Hoa hồng đón tiếp", key: `rose_welcome` },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col md={8} xs={12}>
                        <Row className="h-100">
                            <Col md={6} xs={12}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                <span className={styles.textTag3}>Tổng quan thi đua: </span>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className={styles.textTag}> </span>
                                            <br />
                                            <br />
                                            <span className={styles.textTag4}></span>
                                            <span className={styles.textTag4}></span>
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag}>
                                                {convertCurrency(totalPaid)}</span>
                                            <br />
                                            <span className={styles.textTag2}> 0</span>
                                            <span className={styles.textTag2}> 0</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>

                        </Row>
                    </Col>
                </Row>
                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={12}>
                        <div style={{ backgroundColor: "white" }} >
                            <div className="border-bottom mb-1 p-2">
                                <strong className="m-2">Bảng dữ liệu chi tiết</strong>
                            </div>
                            <div style={{ height: 495, width: '100%' }} className="p-2">
                                <Table 
                                    columns={columns} 
                                    dataSource={[...table]}
                                    pagination={{ pageSize: pageSize }}
                                    scroll={{ x: 900 }}
                                    onChange={handleChange}
                                    bordered
                                    rowKey="id"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
        </>
    )
}
export default ReportEmulation